'use client'

import { useScrollReveal } from '@/hooks/use-scroll-reveal'

interface ScrollRevealSectionProps {
  children: React.ReactNode
  className?: string
  /** Delay in ms before starting animation (for sibling stagger, 60ms increments) */
  delay?: number
}

/**
 * Scroll-reveal wrapper for marketing section content.
 * Applies opacity 0→1 + translateY(12px→0), 280ms ease-out per spec §E.
 * Use around section headings and card grids — NOT around hero content (page-load only).
 */
export function ScrollRevealSection({ children, className, delay = 0 }: ScrollRevealSectionProps) {
  const { ref, isVisible } = useScrollReveal<HTMLDivElement>()

  return (
    <div
      ref={ref}
      className={className}
      style={{
        opacity: isVisible ? 1 : 0,
        transform: isVisible ? 'translateY(0)' : 'translateY(12px)',
        transition: `opacity 280ms ease-out ${delay}ms, transform 280ms ease-out ${delay}ms`,
      }}
    >
      {children}
    </div>
  )
}
